module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("Энергоаудит")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('columns', [_c('column', {
    attrs: {
      "size": "10"
    }
  }, [_c('p', [_vm._v("Независимое всестороннее обследование энергетических систем и оборудования с целью определения:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("их фактического состояния и соответствия действующим нормативам;")]), _vm._v(" "), _c('li', [_vm._v("резервов энергосбережения и повышения энергоэффективности;")]), _vm._v(" "), _c('li', [_vm._v("программы энергосберегающих мероприятий, включая:")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Сокращение расходования электроэнергии;")]), _vm._v(" "), _c('li', [_vm._v("Повышение энергоэффективности и надежности энергооборудования и систем;")])]), _vm._v(" "), _c('p', [_vm._v("Для потребителей энергетический аудит – ценнейший инструмент принятия решений в области организации и обеспечения качественного, надежного, энергоэффективного и безопасного функционирования предприятия.")])])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('aside-image', {
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9cef544"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Audit.vue
// module id = 140
// module chunks = 0